import { render, staticRenderFns } from "./IdentificationReassign.vue?vue&type=template&id=28781054&"
import script from "./IdentificationReassign.vue?vue&type=script&lang=js&"
export * from "./IdentificationReassign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports